import { useMultiExchangeRatio } from '@/hooks/multi-exchange-ratio/useMultiExchangeRatio';
import { MultiExchangeAggregator } from '@/models/multi-exchange-aggregator';
import { MultiExchangeRateSnapshot } from '@/models/multi-exchange-rate-snapshots';
import { WalletService } from '@starsoft/common/services';
import { MultiExchangeCellProps } from './props';

export default function MultiExchangeCell({ row }: MultiExchangeCellProps) {
  const { getConvertedExchangeRatio, currentCoin } = useMultiExchangeRatio();

  function getConvertedAmount(
    row: MultiExchangeRateSnapshot | MultiExchangeAggregator,
  ) {
    if (row instanceof MultiExchangeRateSnapshot) {
      return getConvertedExchangeRatio(row);
    }
    return row?.[currentCoin?.code];
  }

  const convertedAmount = getConvertedAmount(row);

  return (
    <>
      {WalletService.maskCurrency({
        amount: convertedAmount,
        coin: currentCoin,
      })}
    </>
  );
}
